import { ItemType, AssetType } from "@thenounproject/lingo-core";

type VerticalSpacing = {
  mt: string;
  mb: string;
};

export function getGalleryHeadingSpacing(index: number): VerticalSpacing {
  let mt = "xl";
  const isFirstItem = index === 0;

  if (isFirstItem) {
    mt = "none";
  }

  return { mt, mb: "m" };
}

export function getGalleryNoteSpacing(prevItemType: ItemType, index: number): VerticalSpacing {
  let mt = "none";
  const isFirstItem = index === 0,
    isAfterNoteOrHeading = [ItemType.heading, ItemType.note].includes(prevItemType);

  if (isFirstItem || isAfterNoteOrHeading) {
    mt = "none";
  }

  return { mt, mb: "m" };
}

export function getGallerySupportSpacing(prevItemType: ItemType, index: number): VerticalSpacing {
  let mt = "none";
  const isFirstItem = index === 0,
    isAfterHeading = ItemType.heading === prevItemType;

  if (isFirstItem || isAfterHeading) {
    mt = "none";
  }

  return { mt, mb: "m" };
}

export function getGalleryCodeSpacing(prevItemType: ItemType, index: number): VerticalSpacing {
  let mt = "none";
  const isFirstItem = index === 0,
    isAfterHeading = [ItemType.heading].includes(prevItemType);

  if (isFirstItem || isAfterHeading) {
    mt = "none";
  }

  return { mt, mb: "m" };
}

export function getGalleryGuideSpacing(
  prevItemType: string,
  secondPreviousItemType: string,
  guidePosition: "left" | "right" | "full",
  index: number
): VerticalSpacing {
  let mt = "none";
  const isFirstItem = index === 0,
    isAfterHeading = ItemType.heading === prevItemType,
    isHalfGuideInSecondPosition = guidePosition === "right" && index === 1,
    isSecondHalfGuideAfterHeading =
      guidePosition === "right" && ItemType.heading === secondPreviousItemType;

  if (
    isFirstItem ||
    isAfterHeading ||
    isHalfGuideInSecondPosition ||
    isSecondHalfGuideAfterHeading
  ) {
    mt = "none";
  }

  return { mt, mb: "m" };
}

export function getGalleryFontSpacing(
  prevAssetType: string,
  prevItemType: ItemType,
  nextAssetType: string,
  index: number
): VerticalSpacing {
  let mt = "none";
  let mb = "m";

  const isAfterHeadingOrNote = [ItemType.heading, ItemType.note].includes(prevItemType);
  const isAfterFont = prevAssetType === AssetType.textStyle;
  const isBeforeFont = nextAssetType === AssetType.textStyle;
  const isFirstItem = index === 0;

  if (isAfterHeadingOrNote || isAfterFont || isFirstItem) {
    mt = "none";
  }

  if (isBeforeFont) {
    mb = "4px";
  }

  return { mt, mb };
}

export function getGalleryGenericAssetSpacing(
  prevAssetType: string,
  prevItemType: ItemType,
  nextAssetType: string,
  index: number
): VerticalSpacing {
  let mt = "none";
  let mb = "m";

  const isAfterHeadingOrNote = [ItemType.heading, ItemType.note].includes(prevItemType);
  const isAfterGeneric = AssetType.genericTypes.has(prevAssetType);
  const isBeforeGeneric = AssetType.genericTypes.has(nextAssetType);
  const isAfterAudio = AssetType.audioTypes.has(prevAssetType);
  const isBeforeAudio = AssetType.audioTypes.has(nextAssetType);
  const isFirstItem = index === 0;

  if (isAfterHeadingOrNote || isAfterGeneric || isAfterAudio || isFirstItem) {
    mt = "none";
  }

  if (isBeforeGeneric || isBeforeAudio) {
    mb = "4px";
  }

  return { mt, mb };
}

export function getGalleryAssetSpacing({
  isFullWidthAsset,
  prevAssetIsFullWidth,
  isFirstItem,
}: {
  isFullWidthAsset: boolean;
  prevAssetIsFullWidth: boolean;
  isFirstItem: boolean;
}): VerticalSpacing {
  let mt = "none";
  const mb = "m";

  if ((isFullWidthAsset && prevAssetIsFullWidth) || (isFirstItem && isFullWidthAsset)) mt = "none";

  return { mt, mb };
}

export function getGalleryItemSpacing(prevItemType: ItemType, index: number): VerticalSpacing {
  let mt = "none";
  const isFirstItem = index === 0,
    isAfterHeading = ItemType.heading === prevItemType;

  if (isFirstItem || isAfterHeading) {
    mt = "none";
  }

  return { mt, mb: "m" };
}
